import React, { Component } from 'react'
import '../css/App.css'
import { Link } from 'react-router-dom'
import Fadownload from 'react-icons/lib/fa/download'
import FaFileExcel from 'react-icons/lib/fa/file-excel-o'
import FaFileAlt from 'react-icons/lib/fa/file-text-o'
import FaFileaPdf from 'react-icons/lib/fa/file-pdf-o'
import FaFile from 'react-icons/lib/fa/file-o'
import PartyFilter from './PartyFilter'
import Select, { createFilter } from 'react-select';
import { Dropdown } from 'semantic-ui-react';

class FilterOptions extends Component {
    componentWillReceiveProps() {
        window.$("label[disabled]").click((e) => e.stopPropagation());
    }

    handleChange = (newValue, actionMeta) => {
        let event = {
            preventDefault: () => { },
            target: {
                value: newValue ? newValue.value : ''
            }
        };
        this.props.getResultsByPrecinctNum(event);
    };

    getOptions = (precinctAddressesList = null) => {
        const emptyOptions = [
            {
                text: 'No options available...',
                disabled: true,
                key: -1,
                value: -1,
            }
        ];
        if (precinctAddressesList == null) {
            return emptyOptions;
        }
        if (!(precinctAddressesList && precinctAddressesList.length)) {
            return emptyOptions;
        }
        return (precinctAddressesList.map((item, index) => {
            return ({
                text: item.label,
                value: item.value,
                key: index,
            });
        }));
    }


    render() {
        const { Wards, Precincts, ancs, electionCode, PrecinctAddresses, precinctAddressSelected, precinctAddressDefault,
            precinctSelected, wardSelected, ancSelected, filter,
            getResultsByWard, getResultsByCity, getResultsByPrecinct,
            getResultsByPrecinctNum, getResultsByWardNum, getResultsByANC,
            getResultsByANCNum, importId, dateId, isStatsPage, isPublic, resultsId,
            CsvLink, ExcelLink, PdfLink, XmlLink, isWardPrecinctAvailable,
            officeList, curOffice, currentVersion, slug, parties, curParty, clearPartyFilter, getPartyResults, goToResOrStats } = this.props
        //  const linkPrefix = 'http://electionresults.dcboe.org/Downloads/Reports/'    
        //console.log("precinctAddresses => ", PrecinctAddresses);
        const filterConfig = {
            ignoreCase: true,
            ignoreAccents: true,
            trim: true,
            matchFrom: 'any'
        };

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "13px",
                borderBottom: '1px dotted #a3a3a3',
                padding: 10
            })
        }

        //console.log(PrecinctAddresses);
        const width  = window.innerWidth || document.documentElement.clientWidth || 
        document.body.clientWidth;
        const hasPrimarySpecialLink = ((this.props.electionDate === '2022-06-21T00:00:00' || this.props.electionDate === '2024-06-04T00:00:00') && electionCode === 'P') ? true : false;
        const hasGeneralSpecialLink = (this.props.electionDate === '2022-11-08T00:00:00' && electionCode === 'G') ? true : false;
        const hasSpecialSpecialLink = (this.props.electionDate === '2025-07-15T00:00:00' && electionCode === 'S') ? true : false;
        return (
            <React.Fragment>
                <div id='filternav'>
                    <div className='content row filterbox' style={{ background: 'white', boxShadow: '5px 5px 15px grey' }} aria-live="polite">
                        <section className="category-row row col-md-12 mx-auto" style={{ marginBottom: '8px' }}>
                            <div className='col-xs-12 col-sm-12 col-lg-7'>
                                <label style={{ position: 'relative', top: '-10px', left: '-10px', marginRight: '10px' }}>Results Category</label>
                                <div className="btn-group btn-group-toggle navHorizontal" data-toggle="buttons" aria-label="Filters" style={{ marginBottom: '20px', marginLeft: '-9px' }}>
                                    <label htmlFor='cityfilter' className={((electionCode == 'G' || electionCode == 'S') && ancs && !isStatsPage ? 'btn btn-white' : 'btn btn-white-primary') + (filter == 'city' ? ' active' : '')} onClick={(e) => (getResultsByCity(e, true))} >
                                        <input id='cityfilter' type="radio" name="filter" value='city' autoComplete="off" /> Citywide
                                    </label>
                                    <label htmlFor='wardfilter' className={((electionCode == 'G' || electionCode == 'S') && ancs && !isStatsPage ? 'btn btn-white' : 'btn btn-white-primary') + (filter == 'ward' ? ' active' : '')} disabled={isStatsPage && !isWardPrecinctAvailable} onClick={getResultsByWard}>
                                        <input id='wardfilter' type="radio" name="filter" value='ward' autoComplete="off" /> Ward
                                    </label>
                                    <label htmlFor='precinctfilter' className={((electionCode == 'G' || electionCode == 'S') && ancs && !isStatsPage ? 'btn btn-white' : 'btn btn-white-primary') + (filter == 'precinct' ? ' active' : '')} style={{ borderRightWidth: (electionCode == 'G' && !isStatsPage ? '0px' : '0.5px') }} disabled={isStatsPage && !isWardPrecinctAvailable} onClick={getResultsByPrecinct}>
                                        <input id='precinctfilter' type="radio" name="filter" value='precinct' autoComplete="off" /> Precinct
                                    </label>
                                    {(electionCode == 'G' || electionCode == 'S') && ancs && !isStatsPage && <label htmlFor='ancfilter' className={(filter == 'anc' ? 'active ' : '') + 'btn btn-white'} style={{ borderRightWidth: '0.5px' }} onClick={getResultsByANC}>
                                        <input id='ancfilter' type="radio" name="filter" value='anc' autoComplete="off" /> ANC
                                    </label>
                                    }
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-12 col-lg-5'>
                                <div className='row' style={{display:'flex', justifyContent:width >992 ? 'flex-end': 'flex-start', alignItems:'center'}}>
                                    <div className='row' style={{
                                        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                                        marginRight: '1rem', position: "relative", top: (hasPrimarySpecialLink || hasGeneralSpecialLink || hasSpecialSpecialLink) ? '-0.76rem' : '0'
                                    }}>
                                    {
                                        this.props.electionDate === '2025-07-15T00:00:00' &&
                                        <a
                                            style={{ marginBottom: '0.25rem' }}
                                            target="_blank"
                                                    href={'/Downloads/Reports/July_15_2025_Special_Election_Unofficial_Write-In.pdf'}><span><b>Write-In Candidates </b></span>
                                            <FaFileaPdf style={{ color: '#ea3434' }} />
                                        </a>
                                    }
                                    {
                                        this.props.electionDate === '2024-11-05T00:00:00' &&
                                        <a
                                            style={{ marginBottom: '0.25rem' }}
                                            target="_blank"
                                            href={'/Downloads/Reports/November_5_2024_General_Election_Write-In.pdf'}><span><b>Write-In Candidates </b></span>
                                            <FaFileaPdf style={{ color: '#ea3434' }} />
                                        </a>
                                    }
                                    {
                                        hasPrimarySpecialLink && this.props.electionDate === '2024-06-04T00:00:00' &&
                                        <a 
                                            style={{marginBottom:'0.25rem'}}
                                            target="_blank"
                                                    href={'/Downloads/Reports/June_4_2024_Primary_Election_Write-In.pdf'}><span><b>Write-In Candidates </b></span>
                                            <FaFileaPdf style={{ color: '#ea3434' }} />
                                        </a>
                                    }
                                    {
                                        hasPrimarySpecialLink && this.props.electionDate === '2022-06-21T00:00:00' &&
                                        <a
                                            style={{ marginBottom: '0.25rem' }}
                                            target="_blank"
                                            href={'/Downloads/Reports/June_21_2022_Primary_Election_Write-In_Candidates_Primary_2022b.pdf'}><span><b>Write-In Contest Winners </b></span>
                                            <FaFileaPdf style={{ color: '#ea3434' }} />
                                        </a>
                                    }
                                    {
                                        hasGeneralSpecialLink &&
                                        <a
                                            style={{ marginBottom: '0.25rem' }}
                                            target="_blank"
                                                href={'/Downloads/Reports/November_08_2022_General_Election_Write-In.pdf'}><span><b>Write-In Contest Winners </b></span>
                                            <FaFileaPdf style={{ color: '#ea3434' }} />
                                        </a>
                                    }
                                    {(ExcelLink || CsvLink || XmlLink || PdfLink) ?
                                        <div style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '10px' }} >
                                            <button
                                                className="btn btn-info dropdown-toggle" type="button"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Fadownload /> Download Summary Reports | </button>
                                            <div className="dropdown-menu">
                                                {ExcelLink && <a className="dropdown-item" href={ExcelLink} download><span>Results in Excel format </span>
                                                    <FaFileExcel style={{ color: '#78de58' }} />
                                                </a>}
                                                {CsvLink && <a className="dropdown-item" href={CsvLink} download><span>Results in CSV format </span>
                                                    <FaFile style={{ color: '#588fde' }} />
                                                </a>}
                                                {XmlLink && <a className="dropdown-item" href={XmlLink} download><span>Results in XML format </span>
                                                    <FaFileAlt style={{ color: '#8b9089' }} />
                                                </a>}
                                                {PdfLink && <a className="dropdown-item" href={PdfLink} download><span>Results in PDF format </span>
                                                    <FaFileaPdf style={{ color: '#ea3434' }} />
                                                </a>}
                                            </div>
                                        </div> : null}
                                    </div>
                                    

                                    {/*{electionYear == '2008' && electionCode=='G' &&
                                    <div style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '10px' }} >
                                        <button
                                            className="btn btn-info dropdown-toggle" type="button"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Fadownload /> Download Data | </button>
                                        <div className="dropdown-menu">
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Summary.xls'} download><span>City-wide Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Ward.xls'} download><span>Ward Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Precinct.xls'} download><span>Precincts Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Summary.pdf'} download><span>City-wide Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Ward.pdf'} download><span>Ward Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'General_08_Certified_Results_Precinct.pdf'} download><span>Precincts Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                        </div> 
                                    </div>}*/}

                                    {/*{electionYear == '2008' && electionCode=='P' &&
                                    <div style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '10px' }} >
                                        <button
                                            className="btn btn-info dropdown-toggle" type="button"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Fadownload /> Download Data | </button>
                                        <div className="dropdown-menu">
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Summary.xls'} download><span>City-wide Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Ward.xls'} download><span>Ward Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Precinct.xls'} download><span>Precincts Results in Excel format </span>
                                                <FaFileExcel style={{ color: '#78de58' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Summary.pdf'} download><span>City-wide Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Ward.pdf'} download><span>Ward Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                            <a className="dropdown-item" href={linkPrefix + 'Primary_08_Certified_Results_Precinct.pdf'} download><span>Precincts Results in PDF format </span>
                                                <FaFileaPdf style={{ color: '#ea3434' }} />
                                            </a>
                                        </div> 
                                    </div>}*/}

                                    <div style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '10px' }} >
                                        {isPublic && !isStatsPage && (filter == 'city' || ((filter == 'ward' || filter == 'precinct') && isWardPrecinctAvailable)) && <Link to={`/election_statistics/${resultsId}`} className='btn btn-primary float-right'>Voting Statistics</Link>}
                                        {isPublic && isStatsPage && <Link to={`/election_results/${resultsId}`} className='btn btn-primary float-right'>Back to Results</Link>}
                                        {!isPublic && !isStatsPage && (filter == 'city' || ((filter == 'ward' || filter == 'precinct') && isWardPrecinctAvailable)) && <Link to={`/admin/election_statistics/${importId}/${dateId}/${slug}`} className='btn btn-primary float-right' >Voting Statistics</Link>}
                                        {!isPublic && isStatsPage && <Link to={`/admin/election_results/${importId}/${dateId}/${slug}`} className='btn btn-primary float-right'>Back to Results</Link>}
                                    </div>
                                </div>
                            </div>

                        </section>

                        {filter == 'ward' && <div id='wardbuttons' style={{ width: '100%' }}>
                            <div className="wardHorizontal">
                                {Wards.map((wardname, index, arr) => (
                                    <label key={wardname} style={{ fontSize: '13px' }} className={wardname == wardSelected ? 'ward-button active' : 'ward-button'} onClick={(e) => getResultsByWardNum(e, wardname)}>
                                        <input type="radio" name="wardSelected" autoComplete="off" value={wardname} hidden />
                                        {(Number.isInteger(wardname) ? "Ward " : "")} <span>{wardname}</span>
                                    </label>

                                ))
                                }
                            </div>
                        </div>
                        }

                        {filter == 'precinct' &&
                            <div className='precinct-bar'>
                                <div className={'col-sm-12 col-md-8' } >
                                    <div >
                                        <Dropdown
                                            placeholder='Select a Precinct'
                                            fluid
                                            search
                                            selection
                                            value={precinctSelected}
                                            options={this.getOptions(PrecinctAddresses)}
                                            onChange={(e, { value }) => {
                                                this.props.getResultsByPrecinctNum(value);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        }

                        <div className='col-12 row mx-auto' style={{ borderTop: '1px solid lightgray' }}>

                            {parties &&
                                <div id='partyfilter' className="col-md-8 col-sm-12">
                                    <PartyFilter parties={parties}
                                        curParty={curParty}
                                        clearPartyFilter={clearPartyFilter}
                                        getPartyResults={getPartyResults}
                                    />
                                </div>
                            }


                            {filter == 'ward' && <div className={'col-md-3 col-lg-2 wardVertical ' + (electionCode == 'P' ? 'leftborder' : 'rightborder')}>
                                {/*<label htmlFor='wardSelected' className='mr-1'>Select a Ward </label>*/}
                                <select id='wardSelected' className='form-control mydropdown' value={wardSelected} name="wardSelected" onChange={getResultsByWardNum} style={{ width: '100%' }}>
                                    {
                                        Wards.map(wardname => (
                                            <option key={wardname} value={wardname}>{"Ward " + wardname}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            }



                            {filter == 'anc' && <div className={'col-md-3 col-lg-2 ' + (electionCode == 'P' ? 'leftborder' : 'rightborder')} >
                                {/*<label htmlFor='ancSelected' className='mr-1'>Select an ANC </label>*/}
                                <select id='ancSelected' className='form-control mydropdown' value={ancSelected} name="ancSelected" onChange={getResultsByANCNum} style={{ width: '100%' }}>
                                    {
                                        ancs.map(ancname => (
                                            <option key={ancname} value={ancname}>{ancname}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            }

                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default FilterOptions


// WEBPACK FOOTER //
// ./src/components/FilterOptions.js